<template>
  <div class="container">
    <div class="containerTop">
      <a-input allowClear v-model="query.budget_name" placeholder="请输入类预算名称" @keyup.enter.native="search" class="a_input_self margin_self"/>
      <a-select allowClear  placeholder="请选择状态" v-model="query.state"  style="width:220px;margin-left: 10px;" >
        <a-select-option :value="item.id" v-for="(item, index) in statusList" :key="index">
          {{ item.value }}
        </a-select-option>
      </a-select>
      <a-button type="primary" @click="search" style="margin-left: 10px;"> 查询 </a-button>
      <a-button type="primary" ghost @click="reset"> 重置 </a-button>
    </div>
     <a-button type="primary" icon="plus" @click="addApply()" style="margin-bottom: 10px;">新增预算</a-button>
     <div class="containerCenter">
         <a-table :data-source="budgetList" ref="bodyTop" :pagination="pagination"  @change="handleTableChange" bordered>
            <a-table-column key="budget_name" data-index="budget_name" title="名称"  />
            <a-table-column key="start_year" data-index="start_year" title="预算财年"  />
            <a-table-column key="budget_circle" data-index="budget_circle" title="预算周期"  />
            <a-table-column key="overhead_method" data-index="overhead_method" title="预算超额限制">
              <template scope="text">
                  <span>{{text==1?'禁止单据提交': ' '}}</span>
							</template>
            </a-table-column>

            <a-table-column key="state" data-index="state" title="状态">
               	<template scope="text">
                  <a-tag :color="statusList[text].color">
                    {{ statusList[text].value }}
                  </a-tag>
							</template>
            </a-table-column>
            <a-table-column key="first_start" data-index="first_start" title="首次启用时间"  />
            <a-table-column key="create_by" data-index="create_by" title="创建人"  />
            <a-table-column key="create_time" data-index="create_time" title="创建时间"  />
            <a-table-column key="action" title="操作" width="240px" >
              <template slot-scope="text, record">
                <span>
                  <a @click.stop="changeState(record)" v-if="record.state != 0 && record.state != 1">{{record.state==3?'启用':'禁用'}}</a>
                   <a-divider type="vertical" v-if="record.state != 0 && record.state != 1"/>
                  <a @click.stop="detail(record)">查看</a>
                   <a-divider type="vertical" />
                  <a @click.stop="edit(record)" v-if="record.state == 0">编辑</a>
                   <a-divider type="vertical" v-if="record.state == 0" />
                  <a @click.stop="remove(record)">删除</a>
                </span>
              </template>
            </a-table-column>
          </a-table>
     </div>
     <budget-plane ref="budgetPlane" @changeData="search"></budget-plane>
     <edit-budget ref="editBudget" @changeData="search"></edit-budget>
  </div>
</template>

<script>
import budgetPlane from './budgetPlane.vue'
import editBudget from './editBudget.vue'
import {getTemplateAll, delTemplate, templateDisable} from '@/api/budget'

export default {
   components: {
     budgetPlane,
     editBudget
    },
    created() {
      this.search()

    },
    data() {
      return {
        // 0 草稿 1 已过期 2 启用 3 禁用
        statusList: [{
          id: 0,
          color: '#FF6200',
          value: '草稿'
        },{
          id: 1,
          color: '#919191',
          value: '已过期'
        },{
          id: 2,
          color: '#51C41B',
          value: '启用'
        },{
          id: 3,
          color: '#F5232D',
          value: '禁用'
        }],
        query: {
          budget_name: '',
          state: undefined
        },
        statusData: [],
        budgetList: [],
        pagination: {
          current: 1,
					pageSize: 10,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showLessItems: true,
					showSizeChanger: true,
        }
      }
    },
  created() {
    this.search()

  },
  methods: {
    //重置
    reset(){
      this.query = {
          budget_name: '',
          state: undefined
        }
      this.search()
    },
    //删除模板
    remove(row) {
      var _this = this;
      console.log(row)
      this.$confirm({
        title: '确认删除此模板吗?',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          delTemplate({ id: row.id }).then(res => {
            if (res.code != 200) {
              return _this.$message.error(res.msg);
            }
            _this.search()
            _this.$message.success('删除成功');
          })
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
    //启用`/禁用`
    changeState(record) {
        var _this = this;
        this.$confirm({
          title: '确认启用此模板吗?',
          okText: '确定',
          okType: 'danger',
          cancelText: '取消',
          onOk() {
            templateDisable({
              id: record.id
            }).then(res => {
              if(res.code == 200) {
                _this.search()
                _this.$message.success(res.msg)
              } else {
                _this.$message.error(res.msg)
              }
            })
          },
          onCancel() {
            console.log('Cancel');
          },
        });
      

    },
    // 编辑
    edit(record) {
      console.log('222222222222222222222')
       this.$nextTick(() => {
        this.$refs.editBudget.init({
          type: 0,
          rowData: record,
        })
      })

    },
    // 查看
    detail(record) {
      console.log('11111111111111111111')
       this.$nextTick(() => {
        this.$refs.editBudget.init({
          type: 1,
          rowData: record,
        })
      })
    },
    addApply() {
      this.$nextTick(() => {
        this.$refs.budgetPlane.init()
      })
    },
    // 查询预算模板
    search() {
      getTemplateAll({
        state: this.query.state,
        budgetName: this.query.budget_name,
        pageNum: this.pagination.current,
				pageSize: this.pagination.pageSize,

      }).then(res => {
        if(res.code == 200) {
          this.budgetList = res.data.list
          this.pagination.total = res.data.totalCount
        } else {
          this.$message.error(res.msg)

        }
      })


    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
			this.search()
		},
  }

}
</script>

<style lang="less" scoped>
.container {
  /* height: 100%;
  width: 100%; */
  margin: 15px;
  .containerTop {
    padding: 15px 0;

  }

}

</style>